import {useStaticQuery, graphql} from 'gatsby'

export const getAllConfig = graphql`
  query GetAllConfig {
    allMdx(filter: {frontmatter: {templateKey: {eq: "config-page"}}}) {
      nodes {
        frontmatter {
          studantCount
        }
      }
    }
  }
`

const useConfigQuery = () => {
  const {allMdx} = useStaticQuery(getAllConfig)
  const config = allMdx.nodes.reduce(
    (acc, item) => ({
      ...acc,
      ...item.frontmatter,
    }),
    {},
  )

  return config
}

export {useConfigQuery}
